export const classes = {
  wrapper: 'flex flex-col items-center',
  list: 'list-disc list-inside pl-4 py-4 text-base',
  card: 'm-4',
};

export const LINKS = {
  articlesOfIncorporationNL:
    'https://s3.eu-central-1.amazonaws.com/condor-investors-content/company_articles/Gecoo%CC%88rdineerde+statuten+Condor+Technologies+NV_dd.+31.01.2018.pdf',
  articlesOfIncorporationFR:
    'https://s3.eu-central-1.amazonaws.com/condor-investors-content/company_articles/TRADUCTION+LIBRE_Statuts+coordonne%CC%81s+Condor+Technologies+NV.PDF',
  registerExtract:
    'https://s3.eu-central-1.amazonaws.com/condor-investors-content/company_other/KBO-Uittreksel+Op+datum+van+27+februari+2018.pdf',
  registerSource:
    'https://kbopub.economie.fgov.be/kbopub/zoeknummerform.html;jsessionid=B071DE23AD690FF9A0D343938683D661.worker4b?lang=en',
  gazetteSource:
    'https://justitie.belgium.be/nl/overheidsdienst_justitie/organisatie/belgisch_staatsblad',
};

export const PUBLICATIONS = [
  {
    name: 'Publicatie Belgisch Staatsblad 2020.02.03. Ontslag Bestuurder',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/company_other/Publicatie+Belgisch+Staatsblad+2020.02.03.+Ontslag+Bestuurder.pdf',
  },
  {
    name: 'Publicatie+Belgisch+Staatsblad+2018.04.25_Uitgifte+converteerbare+obligaties.pdf',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/company_other/Publicatie+Belgisch+Staatsblad+2018.04.25_Uitgifte+converteerbare+obligaties.pdf',
  },
  {
    name: 'Publicatie+Belgisch+Staatsblad+2018.02.7_Wijziging+maatschappelijke+zetel.pdf',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/company_other/Publicatie+Belgisch+Staatsblad+2018.02.7_Wijziging+maatschappelijke+zetel.pdf',
  },
  {
    name: 'Publicatie+Belgisch+Staatsblad+2016.12.15_Buitengewone+algemene+vergadering.pdf',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/company_other/Publicatie+Belgisch+Staatsblad+2016.12.15_Buitengewone+algemene+vergadering.pdf',
  },
  {
    name: 'Publicatie+Belgisch+Staatsblad+2016.07.18_Buitengewone+algemene+vergadering.pdf',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/company_other/Publicatie+Belgisch+Staatsblad+2016.07.18_Buitengewone+algemene+vergadering.pdf',
  },
  {
    name: 'Publicatie+Belgisch+Staatsblad+2015.06.3_Kapitaalverhoging+door+inbreng+in+natura.pdf',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/company_other/Publicatie+Belgisch+Staatsblad+2015.06.3_Kapitaalverhoging+door+inbreng+in+natura.pdf',
  },
  {
    name: 'Publicatie+Belgisch+Staatsblad+2013.03.18_Buitengewone+algemene+vergadering.pdf',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/company_other/Publicatie+Belgisch+Staatsblad+2013.03.18_Buitengewone+algemene+vergadering.pdf',
  },
  {
    name: 'Publicatie+Belgisch+Staatsblad+2012.10.1_Verplaatsing+maatschappelijke+zetel.pdf',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/company_other/Publicatie+Belgisch+Staatsblad+2012.10.1_Verplaatsing+maatschappelijke+zetel.pdf',
  },
];

export const BOARD_OF_DIRECTORS = [
  { name: 'Mr. Guy De Vreese', mandate: 'Managing Director' },
  { name: 'Mr. Philippe Van Acker', mandate: 'Director' },
  { name: 'Mr. Robert Anciaux', mandate: 'Director' },
  { name: 'Mr. Patrick Braun', mandate: 'Director' },
  { name: 'Mr. François Duret', mandate: 'Director' },
  { name: 'Mr. Fabien Duret', mandate: 'Director' },
  { name: 'Mr. Gilles Briquet', mandate: 'Director' },
];
